import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { Modal, ModalContent } from '@amzn/stencil-react-components/modal'
import { Text } from '@amzn/stencil-react-components/text'

export class ArticleDialog extends Component {

  render() {
    
    return (
      <Modal
        dataTestId="Article_Dialog"
        isOpen={this.props.visible} close={this.props.onCloseDialog}>
        <ModalContent
          dataTestId="Article_Dialog_ModalContent"
          titleText={this.props.title}
          closeButtonAltText="Close Button Article Dialog" 
          onCloseButtonClick={this.props.onCloseDialog}
        >
          <Text
            dataTestId="Article_Dialog_Modal_Text">{this.props.body}</Text>
        </ModalContent>
      </Modal>

    );
  }
}

export default withTranslation('translationsV2')(ArticleDialog)

